<footer>
  <div class="navigation">
    <div>
      <img
        src="../../../assets/imagens/foudation_white.svg"
        class="foundation_priest_logo"
        alt=""
      />
    </div>

    <div class="menu_main">
      <button mat-button class="button_menu" [matMenuTriggerFor]="fundation">
        <span class="menu_header">A Fundação</span>
      </button>
      <mat-menu #fundation="matMenu" yPosition="below">
        <div class="buttons">
          <button (click)="scrollTo('page_main', 'foundation')" mat-menu-item>
            Carta do Presidente
          </button>
          <button (click)="scrollTo('second_page', 'foundation')" mat-menu-item>
            Missão Institucional
          </button>
          <button (click)="scrollTo('third_page', 'foundation')" mat-menu-item>
            Biografia
          </button>
          <button (click)="scrollTo('fourth_page', 'foundation')" mat-menu-item>
            A PUC-Rio
          </button>
          <button (click)="scrollTo('fifth_page', 'foundation')" mat-menu-item>
            A FPLF e a PUC-Rio
          </button>
          <button (click)="scrollTo('six_page', 'foundation')" mat-menu-item>
            A Fundação
          </button>
          <button
            (click)="scrollTo('seven_page', 'inovar_group')"
            mat-menu-item
          >
            Núcleo INOVAR
          </button>
        </div>
      </mat-menu>

      <button mat-button class="button_menu" [matMenuTriggerFor]="instituction">
        <span class="menu_header">Institucional</span>
      </button>
      <mat-menu #instituction="matMenu" yPosition="below">
        <div class="buttons">
          <button
            (click)="scrollTo('page_main', 'institutional')"
            mat-menu-item
          >
            Conceito Jurídico
          </button>
          <button
            (click)="scrollTo('second_page', 'institutional')"
            mat-menu-item
          >
            Ata da Instituição
          </button>
          <button
            (click)="scrollTo('third_page', 'institutional')"
            mat-menu-item
          >
            Instalações
          </button>
        </div>
      </mat-menu>

      <button mat-button class="button_menu" [matMenuTriggerFor]="midias">
        <span class="menu_header"> Mídias </span>
      </button>
      <mat-menu #midias="matMenu" yPosition="below">
        <div class="buttons">
          <button (click)="scrollTo('page_main', 'midia')" mat-menu-item>
            Video Institucional
          </button>
          <button (click)="scrollTo('second_page', 'midia')" mat-menu-item>
            Galeria Institucional
          </button>
        </div>
      </mat-menu>

      <!-- <button mat-button class="button_menu" [matMenuTriggerFor]="filantropy">
        <span class="menu_header">Filantropia</span>
      </button>
      <mat-menu #filantropy="matMenu" xPosition="before">
        <div class="buttons">
          <button mat-menu-item>Item 1</button>
          <button mat-menu-item>Item 2</button>
        </div>
      </mat-menu>-->

      <!-- <button mat-button class="button_menu" routerLink="/fourty-years">
        <span class="menu_header">40 Anos</span>
      </button> -->

      <!-- <button mat-button class="button_menu" routerLink="/mostracultural">
        <span class="menu_header">Edital</span>
      </button> -->

      <!-- <button mat-button class="button_menu" [matMenuTriggerFor]="contactMenu">
        <span class="menu_header">Contato</span>
      </button>
      <mat-menu #contactMenu="matMenu" xPosition="after">
        <div class="buttons">
          <button mat-menu-item>C - 1</button>
          <button mat-menu-item>D - 2</button>
        </div>
      </mat-menu> -->

      <a
        href="http://www.fplf.org.br/extrato-web/index.html"
        id="button_access"
        mat-flat-button
        color="accent"
        rel="noopener noreferrer"
        target="_blank"
      >
        <span class="menu_button_header">Acessar portal</span>
      </a>
    </div>
  </div>

  <div class="texts">
    <span class="copy"> &copy;2005 Fundação Padre Leonel Franca </span>

    <span class="address">
      R. Marquês de São Vicente, 225 · Ed. Padre Leonel Franca, 9o-13o andar ·
      Gávea · Rio de Janeiro, RJ · Brasil · 22451-900
      <br />
      tel +55 (21) 2540-6915 · fax +55 (21) 2511-5645
    </span>
  </div>
</footer>
